<template>
  <div>
      <v-app>
        <v-img src="" class="background-display">
        <v-container>
        <v-card width="600" class="mx-auto mt-5">
          <v-snackbar v-model="snackbar" top :timeout="3000">
            <span>Se le ha enviado a su correo un código y un link para confirmar su registro de usuario</span>
            <v-btn text color="#00b2bb" @click="snackbarMsg">Cerrar</v-btn>
          </v-snackbar>
          <v-toolbar dark color="#00b2bb">
            <v-card-title>
              <span class="headline font-weight-thin">Registrarse</span>
            </v-card-title>
          </v-toolbar>
          <v-progress-linear v-if="apiRequest" indeterminate color="teal" dark></v-progress-linear>
          <v-card-text>
            <v-alert v-model="alert" border="left" close-text="Close Alert" class="hidden-xs-only" dismissible dense outlined type="error">
              Ha ocurrido un error al registrarse.
            </v-alert>
            <v-alert v-model="alertEmail" border="left" close-text="Close Alert" class="hidden-xs-only" dismissible dense outlined type="error">
              Error! El correo ya existe
            </v-alert>
            <v-alert v-model="confirmEmailAlert" border="left" close-text="Close Alert" class="hidden-xs-only" dismissible dense outlined type="error">
              El correo no es el mismo
            </v-alert>
            <v-alert v-model="confirmPasswordAlert" border="left" close-text="Close Alert" class="hidden-xs-only" dismissible dense outlined type="error">
              La contraseña no es la misma
            </v-alert>
            <v-form ref="form"> <!-- El ref es para las validaciones -->
              <v-row>
                <v-col cols="12" xs="12" sm="6">
                  <v-text-field v-model="firstName" :rules="userNameRules" label="Primer Nombre" prepend-icon="mdi-account"/>
                </v-col>
                <v-col  cols="12" xs="12" sm="6">
                  <v-text-field v-model="secondName"  label="Segundo Nombre (Opcional)" prepend-icon="mdi-account"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="6">
                  <v-text-field v-model="lastName" :rules="userNameRules" label="Apellido Paterno" prepend-icon="mdi-account"/>
                </v-col>
                <v-col  cols="12" xs="12" sm="6">
                  <v-text-field v-model="lastName2" :rules="userNameRules" label="Apellido Materno" prepend-icon="mdi-account"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col  cols="12" xs="12" sm="6">
                  <EmailField
                    v-model="email"
                    :name="email"
                    :schema="{
                      label: 'Correo',
                      icon: 'mdi-email'
                    }"
                    solo
                  >
                  </EmailField>
                </v-col>
                <v-col  cols="12" xs="12" sm="6">
                  <EmailField
                    v-model="emailConfirm"
                    :name="emailConfirm"
                    :schema="{
                      label: 'Confirmar Correo',
                      icon: 'mdi-email'
                    }"
                    solo
                  >
                  </EmailField>
                </v-col>
              </v-row>
              <v-row>
                <v-col  cols="12" xs="12" sm="6">
                  <DateField
                   v-model="date"
                   :name="date"
                   :schema="{
                      label: 'Fecha de Nacimiento',
                      icon:'mdi-calendar'
                    }"
                    solo
                   >
                  </DateField>
                </v-col>
                <v-col  cols="12" xs="12" sm="6">
                  <RutField
                  v-model="rut"
                  :name="rut"
                  :type="rut"
                  :schema="{
                      label: 'RUT',
                      icon: 'mdi-account'
                    }"
                  >
                  </RutField>
                </v-col>
              </v-row>
              <v-row>
                <v-col  cols="12" xs="12" sm="6">
                  <PasswordField
                    v-model="password"
                    :name="password"
                    :schema="{
                      label: 'Contraseña',
                      icon:'mdi-lock'
                    }"
                    >
                  </PasswordField>
                  <p class="ml-8 p-size">Debe contener 8 caracteres, un número y una mayúscula. Ejem: clAve123</p>
                </v-col>
                <v-col  cols="12" xs="12" sm="6">
                  <PasswordField
                    v-model="passwordConfirm"
                    :name="passwordConfirm"
                    :schema="{
                      label: 'Confirmar Contraseña',
                      icon:'mdi-lock'
                    }"
                    >
                  </PasswordField>
                  <p class="ml-8 p-size">Debe contener 8 caracteres, un número y una mayúscula. Ejem: clAve123</p>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-alert v-model="alert" border="left" close-text="Close Alert" class="hidden-sm-and-up" dismissible dense outlined type="error">
              Ha ocurrido un error al registrarse.
            </v-alert>
            <v-alert v-model="alertEmail" border="left" close-text="Close Alert" class="hidden-sm-and-up" dismissible dense outlined type="error">
              Error! El correo ya existe
            </v-alert>
            <v-alert v-model="confirmEmailAlert" border="left" close-text="Close Alert" class="hidden-sm-and-up" dismissible dense outlined type="error">
              El correo no es el mismo
            </v-alert>
            <v-alert v-model="confirmPasswordAlert" border="left" close-text="Close Alert" class="hidden-sm-and-up" dismissible dense outlined type="error">
              La contraseña no es la misma
            </v-alert>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row cols="12" lg="6">
              <template>
                <v-row class="ma-5 justify-left" xs="6" md="4" lg="4">
                  <v-btn color="normal" :to="'/'">Cancelar</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="#00b2bb" dark v-if="!alert || !alertEmail" @click="validationRules"
                  >Registrarse</v-btn>
                </v-row>
              </template>
            </v-row>
          </v-card-actions>
          <p class="ma-5 text-center">Ya tiene una cuenta? <a href="/">Iniciar Sesion</a></p>
          <p class="ma-5 text-center">Si ya se registró y aún no ha ingresado el código <a href="/confirmsignup">ingréselo aquí</a></p>
          <v-card-text class="mt-2"> </v-card-text>
        </v-card>
        </v-container>
        </v-img>
      </v-app>
  </div>
</template>
<style>
.p-size {
  font-size: 11px;
}
.background-display {
  background-color: #f5f5f5 !important;
  width: auto;
  min-height: 100%;
}
</style>
<script>
/* import { Auth } from 'aws-amplify' */
import { Auth } from '@aws-amplify/auth'
/* import numeral from '@/plugins/numeral' */
import DateField from '../../components/fields/birthDate/Field.vue'
import EmailField from '../../components/fields/email/Field.vue'
import PasswordField from '../../components/fields/password/Field.vue'
import RutField from '../../components/fields/rut/Field.vue'
// @ is an alias to /src
export default {
  name: 'SignUp',
  components: {
    DateField,
    EmailField,
    PasswordField,
    RutField
  },
  data: vm => ({
    alert: false,
    alertEmail: false,
    confirmEmailAlert: false,
    confirmPasswordAlert: false,
    snackbar: false,
    apiRequest: false,
    singedIn: false,
    verfication: '0',
    firstName: '',
    secondName: '',
    lastName: '',
    lastName2: '',
    username: '',
    email: '',
    emailConfirm: '',
    passwordConfirm: '',
    rut: '',
    password: '',
    date: '',
    userNameRules: [
      v => !!v || 'El nombre es obligatorio',
      v => (v && v.length >= 2) || 'Debe tener mínimo 2 letras',
      v => /[A-Za-z]/.test(v) || 'El nombre no debe contener números'
    ]
  }),
  /* Metodo para crear la cuenta del usuario */
  methods: {
    async createAccount () {
      this.apiRequest = true /* Progress barr */
      try {
        const signUpResponse = await Auth.signUp({
          username: this.email, /* se coloco email porq se definio como pk */
          password: this.password,
          attributes: {
            email: this.email,
            name: this.username,
            'custom:rut': this.rut,
            'custom:verificado': this.verfication,
            'custom:fechaNacimiento': this.date
          },
          validationData: []// optional
        })
        this.snackbar = true
        /* console.log(signUpResponse) */ /* Asi se pasa la info de una pag a otra */
        /* Se esta guardando en el store la informacion de creacion de usuario */
        this.$store.commit('setSignUpResponse', signUpResponse)
        /* axios.post('usuario', JSON.stringify({ id: store.state.signUpResponse.userSub, nombre: this.username, email: this.email, fechaN: this.dateFormatted, rut: this.rut })) */
        localStorage.setItem('nuevo_usuario', JSON.stringify({ email: this.email }))
        this.apiRequest = false
        this.$router.push({ path: '/confirmsignup' })
      } catch (error) {
        this.apiRequest = false
        console.log(error)
        if (error.message === 'An account with the given email already exists.') {
          this.alertEmail = true
        } else {
          this.alert = true
        }
      }
    },
    validationRules () {
      this.concatNames()
      this.validateEmail()
      this.validatePassword()
      if (this.$refs.form.validate() && !this.confirmEmailAlert && !this.confirmPasswordAlert) {
        this.createAccount()
      }
    },
    snackbarMsg () {
      this.snackbar = true
    },
    concatNames () {
      if (this.secondName) {
        this.username = this.firstName + ' ' + this.secondName + ' ' + this.lastName + ' ' + this.lastName2
      } else {
        this.username = this.firstName + ' ' + this.lastName + ' ' + this.lastName2
      }
    },
    validateEmail () {
      if (this.email === this.emailConfirm) {
        this.confirmEmailAlert = false
      } else {
        this.confirmEmailAlert = true
      }
    },
    validatePassword () {
      if (this.password === this.passwordConfirm) {
        this.confirmPasswordAlert = false
      } else {
        this.confirmPasswordAlert = true
      }
    }
  }
}
</script>
